(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/Collection', './ImageReferenceModel', 'services/imageReferenceExtService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var imageReferenceExtService = require('./../../urls').imageReferenceExtService;
    module.exports = factory(require('backbone-torso/modules/Collection'), require('./ImageReferenceModel'), imageReferenceExtService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoCollection, ImageReferenceModel, imageReferenceExtService) {
  'use strict';

  /**
   * Receives image references from the ImageReferenceExtService which serves the ImageReferenceDTO resource.
   *
   * @class ImageReferenceCollection
   * @static
   * @extends Torso.Collection
   */
  return new (TorsoCollection.extend({
    model: ImageReferenceModel,
    url: imageReferenceExtService,
    fetchHttpAction: 'POST'
  }))();
}));
